module.exports = __webpack_public_path__ + "static/media/history_25.5d3c3606.jpg";